// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2Kzk6","content":"bgenv","bn-content":"_2xiIC"};